'use strict';

/* eslint-disable max-lines-per-function */
angular.module('webAgro1App').controller('ResumoAfericoesCtrl', function($scope) {
  function loadData(_event, _history, markers) {
    $scope.afericoes = markers.map(function(marker) {
      return {
        maquina: marker.objeto.implemento || marker.objeto.maquina,
        tipo: marker.objeto.tipo,
        subtipo: marker.objeto.subtipo,
        densidade: marker.objeto.densidade,
        perda_kg: marker.objeto.perda_kg,
        peso: marker.objeto.peso,
        area: marker.objeto.area,
        usuario: marker.objeto.usuario.nome,
        classificacao: marker.objeto.classificacao,
        velocidade: marker.objeto.velocidade,
        createdAt: new Date(marker.objeto.created_at),
        tipoMedida: marker.objeto.input,
        total_gasto: marker.objeto.total_gasto,
        totais_cana: marker.objeto.totais_cana,
        marker: marker
      };
    }).sort(function(first, second) {
      return first.createdAt.getTime() - second.createdAt.getTime();
    })
      .reduce(function(result, item) {
        result[item.maquina.id] = result[item.maquina.id] || [];
        result[item.maquina.id].push(item);
        return result;
      }, {});
    $scope.afericoesKeys = Object.keys($scope.afericoes);
  }

  $scope.$on('semeadura_afericao', loadData);
  $scope.$on('colheita_afericao', loadData);
  $scope.$on('aplicacao_afericao', loadData);

  $scope.setAnimationMarker = function(marker, index) {
    if (!marker.isOpen) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
      $scope.$emit('startAnimatingMarker', index);
    }
  };

  $scope.resetAnimationMarker = function(marker, index) {
    marker.setAnimation(null);
    $scope.$emit('stopAnimatingMarker', index);
  };

  $scope.openInfoWindow = function(marker, index) {
    $scope.resetAnimationMarker(marker);
    google.maps.event.trigger(marker, 'click');
    $scope.$emit('openMarkerPopup', index);
  };

  const reset = function() {
    delete $scope.afericoes;
    delete $scope.afericoesKeys;
  };

  $scope.$on('colheita_afericao_close', reset);
  $scope.$on('reset', reset);

  $scope.$watch('tipo', function() {
    if ($scope.tipo) {
      if ($scope.tipo.includes('afericao')) {
        return loadData(null, null, $scope.data);
      }
      reset();
    }
  });
});
